var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},[_c('node-tree',{attrs:{"parentId":_vm.ParentDirectory,"node":_vm.treeData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }